import { ActivityLogEntityType } from "./activity-logs.enums";

/**
 * The audit log's filter pills: each entity type belongs to exactly one domain, so the domain counts add up to the
 * total. The API filters and counts by domain; the tenant draws one pill per domain.
 */
export enum ActivityLogDomain {
  Members = "MEMBERS",
  Groups = "GROUPS",
  Finance = "FINANCE",
  Budgets = "BUDGETS",
  Branches = "BRANCHES",
  Access = "ACCESS",
}

export const ACTIVITY_LOG_DOMAINS: readonly ActivityLogDomain[] = [
  ActivityLogDomain.Members,
  ActivityLogDomain.Groups,
  ActivityLogDomain.Finance,
  ActivityLogDomain.Budgets,
  ActivityLogDomain.Branches,
  ActivityLogDomain.Access,
];

export const ACTIVITY_LOG_DOMAIN_ENTITY_TYPES: Readonly<Record<ActivityLogDomain, readonly ActivityLogEntityType[]>> = {
  [ActivityLogDomain.Members]: [
    ActivityLogEntityType.Member,
    ActivityLogEntityType.MemberRelationship,
    ActivityLogEntityType.CustomField,
  ],
  [ActivityLogDomain.Groups]: [ActivityLogEntityType.Group, ActivityLogEntityType.Ministry],
  [ActivityLogDomain.Finance]: [
    ActivityLogEntityType.FinanceTransaction,
    ActivityLogEntityType.IncomeCategory,
    ActivityLogEntityType.ExpenseCategory,
  ],
  [ActivityLogDomain.Budgets]: [ActivityLogEntityType.Budget, ActivityLogEntityType.BudgetLine],
  [ActivityLogDomain.Branches]: [ActivityLogEntityType.Branch],
  [ActivityLogDomain.Access]: [ActivityLogEntityType.User, ActivityLogEntityType.WorkspaceInvitation],
};

export function activityLogDomainOf(entityType: ActivityLogEntityType): ActivityLogDomain | null {
  for (const domain of ACTIVITY_LOG_DOMAINS) {
    if (ACTIVITY_LOG_DOMAIN_ENTITY_TYPES[domain].includes(entityType)) return domain;
  }
  return null;
}

/** A primitive value of a changed field, as stored with the event. */
export type ActivityLogChangeValue = string | number | boolean | null;

/**
 * One field an event changed. `redacted`: the field changed but its values are personal data the audit log does
 * not repeat (contact details, birth date, notes), so only the field name is shown.
 */
export type ActivityLogChange = {
  field: string;
  before: ActivityLogChangeValue;
  after: ActivityLogChangeValue;
  redacted: boolean;
};
